export function getFiltersArray(filters: string[] = []): string[] {
  const [presetFilters, ...restFilters] = filters
  const splitedFilters = presetFilters
    ? presetFilters.split(',').map((filter) => filter.trim())
    : []

  return [...new Set([...splitedFilters, ...restFilters])]
}
